/** Normalises observation choices (record or array) into translated options. */
export function choicesToOptions(choices, translate) {
  if (!choices) return [];
  var list = Array.isArray(choices) ? choices : Object.values(choices);
  return list.map(function (choice) {
    return {
      value: choice.id,
      label: translate(choice.choice),
      disabled: choice.disabled
    };
  });
}